__turbopack_context__.v({
  "container": "JKptBa_container",
  "image": "JKptBa_image",
  "imageContainer": "JKptBa_imageContainer",
});
